//
//  SDKDocsPublishStatus.ts
//  Supernova SDK
//
//  Created by Vsevolod Krasnov.
//
// --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- ---
// MARK: - Publishing status enum
export var DocsPublishStatus;
(function (DocsPublishStatus) {
    DocsPublishStatus[DocsPublishStatus["idle"] = 0] = "idle";
    DocsPublishStatus[DocsPublishStatus["inProgress"] = 1] = "inProgress";
})(DocsPublishStatus || (DocsPublishStatus = {}));
